export const germanCountryList = {
  AC: 'Ascension',
  AF: 'Afghanistan',
  AL: 'Albanien',
  DZ: 'Algerien',
  AS: 'Amerikanisch-Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AG: 'Antigua und Barbuda',
  AR: 'Argentinien',
  AM: 'Armenien',
  AW: 'Aruba',
  AU: 'Australien',
  AT: 'Österreich',
  AZ: 'Aserbaidschan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesch',
  BB: 'Barbados',
  BY: 'Weißrussland',
  BE: 'Belgien',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivien',
  BQ: 'Britisches Antarktis-Territorium',
  BA: 'Bosnien und Herzegowina',
  BW: 'Botsuana',
  BR: 'Brasilien',
  IO: 'Britisches Territorium im Indischen Ozean',
  BN: 'Brunei',
  BG: 'Bulgarien',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  CV: 'Kap Verde',
  KH: 'Kambodscha',
  CM: 'Kamerun',
  CA: 'Kanada',
  KY: 'Caymaninseln / Kaimaninseln',
  CF: 'Zentralafrikanische Republik',
  TD: 'Tschad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Weihnachtsinsel',
  CC: 'Kokosinseln / Keelinginseln',
  CO: 'Kolumbien',
  KM: 'Komoren',
  CD: 'Demokratische Republik Kongo',
  CG: 'Republik Kongo',
  CK: 'Cookinseln',
  CR: 'Costa Rica',
  HR: 'Kroatien',
  CU: 'Kuba',
  CY: 'Zypern',
  CZ: 'Tschechien',
  CI: 'Elfenbeinküste',
  DK: 'Dänemark',
  DJ: 'Dschibuti',
  DM: 'Dominica',
  DO: 'Dominikanische Republik',
  EC: 'Ecuador',
  EG: 'Ägypten',
  SV: 'El Salvador',
  GQ: 'Äquatorialguinea',
  ER: 'Eritrea',
  EE: 'Estland',
  SZ: 'Eswatini (Swasiland)',
  ET: 'Äthiopien',
  FK: 'Falklandinseln',
  FO: 'Färöer (Färöer-Inseln)',
  FJ: 'Fidschi',
  FI: 'Finnland',
  FR: 'Frankreich',
  GF: 'Französisch-Guayana',
  PF: 'Französisch-Polynesien',
  GA: 'Gabun',
  GM: 'Gambia',
  GE: 'Georgien',
  DE: 'Deutschland',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Griechenland',
  GL: 'Grönland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  VA: 'Vatikanstadt (Heiliger Stuhl)',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Ungarn',
  IS: 'Island',
  IN: 'Indien',
  ID: 'Indonesien',
  IR: 'Iran (Persien)',
  IQ: 'Irak',
  IE: 'Irland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italien',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordanien',
  KZ: 'Kasachstan',
  KE: 'Kenia',
  KI: 'Kiribati',
  KP: 'Nordkorea',
  KR: 'Südkorea (Republik Korea)',
  KW: 'Kuwait',
  KG: 'Kirgisistan (Kirgistan)',
  LA: 'Laos',
  LV: 'Lettland',
  LB: 'Libanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libyen',
  LI: 'Liechtenstein',
  LT: 'Litauen',
  LU: 'Luxembourg',
  MO: 'Macau',
  MG: 'Madagaskar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Malediven',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshallinseln',
  MQ: 'Martinique',
  MR: 'Mauritanien',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Föderierte Staaten von Mikronesien',
  MD: 'Moldavien (Republik Moldau)',
  MC: 'Monaco',
  MN: 'Mongolei',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Marokko',
  MZ: 'Mosambik',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Niederlande, Holland',
  NC: 'Neukaledonien',
  NZ: 'Neuseeland',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolkinsel',
  MP: 'Nördliche Marianen',
  NO: 'Norwegen',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Staat Palästina',
  PA: 'Panama',
  PG: 'Papua-Neuguinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippinen',
  PL: 'Polen',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Katar',
  MK: 'Nordmazedonien',
  RO: 'Rumänien',
  RU: 'Russland, Russische Föderation',
  RW: 'Ruanda, Rwanda',
  RE: 'Réunion',
  BL: 'St. Barthélemy',
  SH: 'Saint Helena, Ascension and Tristan da Cunha',
  KN: 'St. Kitts und Nevis',
  LC: 'St. Lucia',
  MF: 'St. Martin (French part)',
  PM: 'St. Pierre und Miquelon',
  VC: 'St. Vincent und die Grenadinen',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'São Tomé und Príncipe',
  SA: 'Saudi-Arabien',
  SN: 'Senegal',
  RS: 'Serbien',
  SC: 'Seychellen',
  SL: 'Sierra Leone',
  SG: 'Singapur',
  SX: 'St. Martin (Dutch part)',
  SK: 'Slowakei',
  SI: 'Slovenien',
  SB: 'Salomonen',
  SO: 'Somalia',
  ZA: 'Südafrika',
  SS: 'Südsudan',
  ES: 'Spanien',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname (Surinam)',
  SJ: 'Svalbard und Jan Mayen',
  SE: 'Schweden',
  CH: 'Schweiz',
  SY: 'Syrien',
  TA: 'Tristan da Cunha',
  TW: 'Republik China (Taiwan)',
  TJ: 'Tadschikistan',
  TZ: 'Tansania',
  TH: 'Thailand',
  TL: 'Osttimor',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad und Tobago',
  TN: 'Tunesien',
  TR: 'Türkei',
  TM: 'Turkmenistan',
  TC: 'Turks- und Caicosinseln',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'Vereinigte Arabische Emirate',
  GB: 'Vereinigtes Königreich',
  US: 'Vereinigte Staaten (USA)',
  UY: 'Uruguay',
  UZ: 'Usbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela',
  VN: 'Vietnam',
  VG: 'Jungferninseln (Britische)',
  VI: 'Jungferninseln (Amerikanische)',
  WF: 'Wallis und Futuna',
  EH: 'Westsahara',
  YE: 'Jemen',
  XK: 'Kosovo',
  ZM: 'Sambia',
  ZW: 'Simbabwe',
  AX: 'Åland Islands',
}
